module.exports = __webpack_public_path__ + "static/media/ug.37868e51.svg";